import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent, LoginComponent, UsersAssignsComponent, UsersComponent } from './components';
import { BinnacleComponent } from './components/binnacle/binnacle.component';
import { ConfigNotificacionesComponent } from './components/config-notificaciones/config-notificaciones.component';
import { NotificacionesComponent } from './components/notificaciones/notificaciones.component';
import { SubscriptionComponent } from './components/subscription/subscription.component';
import { AuthorizationGuard } from './guards/autorization.guard';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'home/' },
  { path: 'home/:UserId', component: HomeComponent, canActivate: [AuthorizationGuard]},
  { path: 'users', component: UsersComponent, canActivate: [AuthorizationGuard]},
  { path: 'user-assigns', component: UsersAssignsComponent, canActivate: [AuthorizationGuard]},
  { path: 'login', component: LoginComponent },
  { path: 'notificaciones', component: NotificacionesComponent, canActivate: [AuthorizationGuard] },
  { path: 'config-notificaciones', component: ConfigNotificacionesComponent, canActivate: [AuthorizationGuard] },
  { path: 'subscriptions', component: SubscriptionComponent},
  { path: 'binnacle', component: BinnacleComponent, canActivate: [AuthorizationGuard]},
  { path: '**', pathMatch: 'full', redirectTo: 'home/'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
